<template>
    <div id="service-staff-setting" class="shadow-md rounded-item">
        <vx-card>
            <div class="setting-card-hidden">
                <div class="setting-card-scroll">
                    <h4 class="text-2xl font-bold">Tip On Device</h4>
                    <div class="flex align-center">
                        <vs-switch v-model="is_tip_on_device" class="my-6" @click.stop="updateStaffReceipt"/>
                        <span class="pl-5">Allow to tip on Clover device at checkout</span>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>
<script>
export default {
    name: 'tip-on-device',
    data() {
        return {
            is_tip_on_device: false,
            loaded_data_num: 0,
            isOpenLoading: false,
            action_type: ''
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 1) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get Data";
                    this.openLoadingInDiv();
                }
            }
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: this.action_type + ' Tip On Device Failed',
                    acceptText: 'OK'
                })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        updateStaffReceipt() {
            const obj = {
                key: 'config.pos.is_tip_on_device',
                value: !this.is_tip_on_device ? 1 : 0
            }
            this.action_type = 'Update';
            this.openLoadingInDiv();
            this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
                this.closeLoading();
                this.$vs.notify({
                title:'Notification',
                text:'Update Tip On Device Success',
                color:'success',
                position:'top-right'})
            });
        }
    },
    created() {
        const obj = {
            key: 'config.pos.is_tip_on_device'
        }

        this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then(() => {
            this.loaded_data_num++;
            let is_tip_on_device = this.$store.getters["appSetting/keyStorage"];
            this.is_tip_on_device = is_tip_on_device.value == 1 ? true : false;
        }).catch(() => {
            const obj = {
                key: 'config.pos.is_tip_on_device',
                value: 0
            }
            this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
                this.loaded_data_num++;
            })
        })
    }
}
</script>

